import {useAuth0} from '@auth0/auth0-react';
import {useQuery} from 'react-query';
import {getMyProfile} from '../Calls/Session';

export const useMyProfile = (enabled: boolean = false) => {
  const {isAuthenticated} = useAuth0();

  // const [claims, setClaims] = useState<IdToken | null>(null);

  // useEffect(() => {
  //   async function getToken() {
  //     const token = await getIdTokenClaims();
  //     setClaims(token);

  //     // wait 1 second before returning
  //   }

  //   if (isAuthenticated) {
  //     setTimeout(() => {
  //       getToken();
  //     }, 100);
  //   }
  // }, [isAuthenticated]);

  return useQuery('PROFILE', getMyProfile, {enabled: enabled && isAuthenticated});
};
